import React from "react";


const RedDotIcon: React.FC<{ h?: number }> = () =><div className={"bg-red-500 rounded-full h-2 w-2"}></div>;

export {RedDotIcon};